"use client"
import React from 'react'
import { Typewriter } from 'react-simple-typewriter'

const TypeWriter = () => {
  return (
    <div className="md:text-2xl text-lg font-bold typing-effect mt-6">
    You can talk to your{" "}
    <span className="text-black">
      <Typewriter
        words={[
          "PDFs",
          "Invoices",
          "Documents",
          "Bills",
          "Contracts",
          "Reports",
        ]}
        loop={true}
        cursor
        cursorStyle="|"
        typeSpeed={150}
        deleteSpeed={50}
        delaySpeed={1500}
      />
    </span>{" "}
    now!!
  </div>
  )
}

export default TypeWriter
